import cx from 'classnames'

import ButtonWithTooltip from 'common/components/ButtonWithTooltip'
import MenuButton, { MenuItem } from 'common/components/menuButton'
import Base from 'common/components/table/cells/Base'
import {
  Bin,
  Check,
  Duplicate,
  Edit,
  MoreLikeThis,
  MoreOptions,
  Refresh,
  Spinner,
} from 'common/icons'
type Props = {
  onCopy: () => void
  onRefresh: () => void
  onDelete: () => void
  onEdit: () => void
  onMoreLikeThis: () => void
  isDisabled?: boolean
  isRefreshSuccessful?: boolean
  isMoreLikeThisSuccessful?: boolean
  isRefreshing: boolean
  isMoreLikeThisEnabled?: boolean
  isLoadingMoreLikeThis?: boolean
}

export const ActionCells = ({
  onCopy,
  onRefresh,
  onDelete,
  onEdit,
  onMoreLikeThis,
  isDisabled,
  isRefreshing,
  isMoreLikeThisSuccessful,
  isRefreshSuccessful,
  isMoreLikeThisEnabled,
  isLoadingMoreLikeThis,
}: Props) => (
  <Base className="text-coolGray-400">
    <ButtonWithTooltip
      tooltip={true}
      tooltipText="Edit"
      aria-label="Edit variant"
      data-testid="edit-variant"
      size="small"
      className={cx({
        'text-coolGray-300':
          isRefreshing || isLoadingMoreLikeThis || isDisabled,
      })}
      disabled={isRefreshing || isLoadingMoreLikeThis || isDisabled}
      prefixIcon={<Edit isDefaultColor={false} />}
      onClick={onEdit}
    />

    <ButtonWithTooltip
      tooltip={true}
      tooltipText={isRefreshing ? 'Refreshing...' : 'Refresh'}
      aria-label="Refresh"
      data-testid="refresh-variant"
      size="small"
      className={cx({ 'text-coolGray-300': isDisabled })}
      disabled={isRefreshing || isDisabled}
      prefixIcon={
        isRefreshSuccessful ? (
          <Check isDefaultColor={false} />
        ) : isRefreshing ? (
          <Spinner className="animate-spin text-maroon-200" />
        ) : (
          <Refresh isDefaultColor={false} />
        )
      }
      onClick={!isRefreshing ? onRefresh : () => {}}
    ></ButtonWithTooltip>
    <MenuButton
      portal
      buttonProps={{
        'aria-label': 'More options',
        'data-testid': 'more-options',
        className: cx('ml-3', {
          'text-coolGray-300':
            isRefreshing || isLoadingMoreLikeThis || isDisabled,
        }),
        children: isLoadingMoreLikeThis ? (
          <Spinner className="animate-spin text-maroon-200" />
        ) : (
          <MoreOptions isDefaultColor={false} />
        ),
        disabled: isRefreshing || isLoadingMoreLikeThis || isDisabled,
      }}
      options={
        <>
          {isMoreLikeThisEnabled && (
            <MenuItem
              key="1"
              onClick={onMoreLikeThis}
              aria-label="More like this"
              data-testid="more-like-this"
              disabled={isRefreshing}
            >
              {isMoreLikeThisSuccessful ? (
                <Check
                  isDefaultColor={false}
                  className="mr-4 text-coolGray-400"
                />
              ) : isLoadingMoreLikeThis ? (
                <Spinner className="animate-spin text-maroon-200 mr-4" />
              ) : (
                <MoreLikeThis
                  isDefaultColor={false}
                  className="mr-4 text-coolGray-400"
                />
              )}
              More like this
            </MenuItem>
          )}
          <MenuItem key="2" onClick={onCopy} aria-label="Copy">
            <Duplicate
              isDefaultColor={false}
              className="mr-4 text-coolGray-400"
            />
            Copy to clipboard
          </MenuItem>
          <MenuItem key="3" onClick={() => onDelete()} aria-label="Delete">
            <Bin isDefaultColor={false} className="mr-4 text-coolGray-400" />
            Delete
          </MenuItem>
        </>
      }
    />
  </Base>
)
